<template>
    <div>
        <app-header :settings='settings' :showdeclarers='showdeclarers'></app-header>

        <div class="page__head container">
            <div class="page__head-inner block">
                <!-- Для этой страницы стиль заголвока h2 -->
                <h3 class="page__title h3">Заявители по подключению к тепловым сетям:</h3>
            </div>
        </div>

        <div class="page__main container">
            <div class="page__index block-index">
                <div class="personal-section">
                    <div class="personal-section__link block">

                        <div class="entity-header__btns declarer-top">
                            <a href="#declarer-types" class="object__ctrl-group collapse-link collapsed js-collapse-toggle" data-toggle="collapse" data-scroll-to="">
                                <div class="object__ctrl-btn button button--th-main">
                                    Добавить Заявителя
                                    <span class="testimony-individual__icon">
                                        <i class="icon icon--add"></i>
                                    </span>
                                </div>
                            </a>
                        </div>
                        <!-- разные типы заявителей -->
                        <div id="declarer-types" class="object-info accordion-body collapse">
                            <div class="object-info__inner accordion-body__inner">
                                <div class="declare-applications object block">
                                    <div class="object__table entity-header">
                                        <div class="object__cell">
                                            <a href="/STS/Declarer/AddUL" class="h2 link status-primary">ЮЛ</a>
                                        </div>
                                    </div>
                                    <div class="object__table entity-header">
                                        <div class="object__cell">
                                            <a href="/STS/Declarer/AddFL" class="h2 link status-primary">ФЛ</a>
                                        </div>
                                    </div>
                                    <div class="object__table entity-header">
                                        <div class="object__cell">
                                            <a href="/STS/Declarer/AddIP" class="h2 link status-primary">ИП</a>
                                        </div>
                                    </div>
                                    <div class="object__table entity-header">
                                        <div class="object__cell">
                                            <a href="/STS/Declarer/AddOMSU" class="h2 link status-primary">ОМСУ</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-drop">
                            <!--<a href="" class="add-drop__toggle link link--underline" data-toggle="dropdown">
            <div class="link__icon fab-icon">
                <i class="icon icon--add"></i>
            </div>
            <div class="link__text">Добавить Заявителя</div>
        </a>
        <div class="add-drop__drop">
            <div class="add-drop__drop-inner">
                <a href="#declarer-types" class="button button--th-main">Добавить Заявителя</a>
            </div>
        </div>-->

                        </div>
                    </div>

                    <declarer 
                        v-for="(declarer, index) in normalizedDeclarers"
                        :key="index"
                        :declarer="declarer"
                    ></declarer>
                </div>
            </div>

            <div class="page__aside block">
                <div class="aside">
                    <div class="aside__item aside__item--divider">
                        <div class="card-promo card-promo--hover card-promo--warning card">
                            <div class="card-promo__bg"></div>
                            <div class="card-promo__head">
                                <div class="card-promo__title h2">Есть вопросы?</div>
                            </div>
                            <div class="card-promo__body">
                                <div class="card-promo__text">
                                    Посмотрите раздел помощи,либо напишите нам лично.
                                </div>
                            </div>
                            <div class="card-promo__footer">
                                <a href="/faq/add" class="link link--underline"><span class="link__text">Помощь</span></a>
                                <a href="/faq/add" class="card-promo__button button button--th-ctrl">Задать вопрос</a>
                            </div>
                        </div>
                    </div>
                    <div class="aside__item aside__item--divider">
                        <a href="/STS/HelpInfo/RegulatoryLegalActs" class="card-promo card-promo--hover card-promo--warning card">
                            <div class="card-promo__bg"></div>
                            <div class="card-promo__head">
                                <div class="card-promo__title h2">Законодательная база</div>
                            </div>
                            <div class="card-promo__body">
                                <div class="card-promo__text">Посмотрите раздел помощи,либо напишите нам лично.</div>
                            </div>
                            <div class="card-promo__footer">
                                <div class="more-link">
                                    <span class="link__text">Подробнее</span>
                                    <span class="more-link__icon fab-icon">
                                        <i class="icon icon--arrow-right"></i>
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="aside__item aside__item--divider">
                        <a href="/STS/HelpInfo/SampleDocuments" class="card-promo card-promo--hover card-promo--warning card">
                            <div class="card-promo__bg"></div>
                            <div class="card-promo__head">
                                <div class="card-promo__title h2">Образцы заявок</div>
                            </div>
                            <div class="card-promo__body">
                                <div class="card-promo__text">Посмотрите раздел помощи,либо напишите нам лично.</div>
                            </div>
                            <div class="card-promo__footer">
                                <div class="more-link">
                                    <span class="link__text">Подробнее</span>
                                    <span class="more-link__icon fab-icon">
                                        <i class="icon icon--arrow-right"></i>
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ProfilesHeader from './ProfilesHeader.vue';
    import Declarer from './Declarer.vue'

    export default {
        name: 'declarers',
        components: {
            'app-header': ProfilesHeader,
            'declarer': Declarer
        },
		props: ['declarers', 'showdeclarers'],
        data: function () {
            return {
                settings: { name: this.$options.name }              
            }
        },
        computed: {
  			normalizedDeclarers: function () {
				return JSON.parse(this.declarers);
			}
        }
    }

</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/Declarers.vue